var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1838_60370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6425 1.3577C16.3871 1.10333 16.0838 0.90209 15.7501 0.765612C15.4165 0.629134 15.0591 0.560122 14.6987 0.562563C14.3382 0.565003 13.9818 0.638849 13.65 0.779832C13.3182 0.920816 13.0177 1.12614 12.7657 1.38395L1.89075 12.2589L0.5625 17.4377L5.74125 16.1095L16.6163 5.23445C16.8741 4.9825 17.0794 4.68196 17.2204 4.35019C17.3614 4.01843 17.4352 3.66202 17.4376 3.30155C17.4401 2.94108 17.3711 2.5837 17.2346 2.25005C17.0981 1.91641 16.8969 1.61312 16.6425 1.3577Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4546 1.69531L16.3051 5.54581",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.884 3.26562L14.7345 7.11612",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89087 12.2578L5.74512 16.1046",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1838_60370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdated);
export default __webpack_public_path__ + "static/media/Updated.e588543f7b0f6ae35fd78bc9b3d39741.svg";
export { ForwardRef as ReactComponent };